module.exports = __webpack_public_path__ + "09_hige_black.b614f58f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/09_hige_black.png
// module id = ORnS
// module chunks = 0